import validate from 'validate.js';
import getContrastRatio from 'get-contrast-ratio';
import moment from 'moment';

const regex = (value, options) => {
  const regExp = new RegExp(options.pattern);

  if (!regExp.test(value)) {
    return options.message;
  }

  return '';
};

const checked = (value, options) => {
  if (value !== true) {
    return options.message || 'must be checked';
  }

  return '';
};

const minRatio = (value, options) => {
  if (!value) {
    return null;
  }

  if (getContrastRatio(value, '#FFFFFF') < options.value) {
    return options.message;
  }

  return null;
};

validate.validators = {
  ...validate.validators,
  regex,
  checked,
  minRatio,
};

validate.validators.email.PATTERN =
  /(^$|(^([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;

validate.extend(validate.validators.datetime, {
  parse(value) {
    return +moment.utc(value);
  },
  format(value) {
    return moment.utc(value).format('YYYY-MM-DD');
  },
});
